import { useEffect, useState } from "react"
import { Link } from 'react-router-dom'
import { Input, Button, Table, Space, message, Select } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete } from "../../tool/axios"
import BreadCrumb from '../../component/BreadCrumb'
import { SelectProductType } from "../../component/common/Selects"
import { PutOnOffsButton } from "../../component/common/Buttons"
import _ from 'lodash'

const { Column } = Table
const { Option } = Select

type fetchParams = {
    goods_type_id: string | undefined
    goods_name: string | undefined
    status: number | undefined
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: false
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        goods_type_id: undefined,
        goods_name: undefined,
        status: undefined
    }

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    // 列表数据
    const [data, setData] = useState<any>([])
    // 列表Loading
    const [loading, setLoading] = useState<boolean>(false)

    const [selectIDs, setSelectIDs] = useState<string[]>([])

    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
    }, [pagination.current])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
    }

    const rowSelectChange = (e: any) => {
        setSelectIDs(e)
    }

    const batchPut = (type: string) => {
        if (selectIDs.length === 0) {
            message.error('至少选择一条数据')
            return
        }

        baseAxiosComplete.post('/mall_center/put_on_off/batch_on_off', {
            id_arr: selectIDs,
            operate_type: type === 'on' ? 1 : 2

        }).then(res => {
            if (res.status === 0) {
                resetForm()
                setSelectIDs([])
            }
        })
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)

        let iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }

        axiosTable.get('/mall_center/put_on_off/page_list', {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)
            }

            setLoading(false)
        })
    }

    const exportExcel = () => {
        let iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }

        baseAxiosComplete('/mall_center/put_on_off/excel', {
            params: {
                ...iPagination,
                ...params
            }

        }).then(res => {
            if (res.status === 0) {
                window.open(res.data)
            }
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    return (<div className="common-page">
        {/* 商城中心 -> 商品管理 -> 商品上架管理 */}
        <BreadCrumb position={['商城中心', '商品上架管理']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <div style={{ marginRight: 5, marginBottom: 12 }}>
                    <SelectProductType value={fetchOtherParams.goods_type_id} onChange={(v: string) => { handleChange(v, 'goods_type_id') }} />
                </div>
                <Input style={{ width: '180px', marginRight: 5, marginBottom: 12 }} placeholder="商品名称" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'goods_name') }} value={fetchOtherParams.goods_name} />

                <Select style={{ width: '120px', marginRight: 5, marginBottom: 12 }} placeholder="商品状态" value={fetchOtherParams.status} onChange={(v: number) => { handleChange(v, 'status') }} >
                    <Option value={1} key="1">上架</Option>
                    <Option value={2} key="2">下架</Option>
                </Select>
            </Space>

            <div style={{ marginTop: 10 }}>
                <Button className="search-btn" style={{ marginRight: 12, marginBottom: 12 }} icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>
                <Button style={{ marginRight: 12, marginBottom: 12 }} type="primary" ><Link to="/product_put_add">添加</Link></Button>
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={exportExcel}>导出</Button>
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={() => { batchPut('on') }}>批量上架</Button>
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={() => { batchPut('off') }}>批量下架</Button>
            </div>
        </div>

        <div className="common-main">
            <Table loading={loading} rowSelection={{ onChange: rowSelectChange, selectedRowKeys: selectIDs }} dataSource={data} scroll={{ x: 'max-content' }} bordered={true} rowKey="id" pagination={pagination} onChange={handleTableChange}>
                <Column title="商品编号" dataIndex="goods_code" key="goods_code" />
                <Column title="商品名称" dataIndex="goods_name" key="goods_name" />
                <Column title="商品分类" dataIndex="goods_type_name" key="goods_type_name" />
                <Column title="上架规格" dataIndex="goods_specs_values" key="goods_specs_values" />
                <Column title="上架库存" dataIndex="inventory_num" key="inventory_num" />
                <Column title="上架售价" dataIndex="sale_price" key="sale_price" />
                <Column title="状态" dataIndex="status" key="status" render={(v: any) => {
                    switch (v) {
                        case 1:
                            return '上架中'
                        case 2:
                            return '下架中'
                    }
                }} />
                <Column title="上架人" dataIndex="put_on_user_name" key="put_on_user_name" />
                <Column title="上架时间" dataIndex="put_on_time" key="put_on_time" />
                <Column title="下架人" dataIndex="put_off_user_name" key="put_off_user_name" />
                <Column title="下架时间" dataIndex="put_off_time" key="put_off_time" />

                <Column
                    title="操作"
                    key="action"
                    render={(text, record: any) => (
                        <Space size="middle">
                            {record.status === 2 && <Link to={"/product_put_edit/" + record.id}>编辑</Link>}
                            {record.status === 1 && <PutOnOffsButton ids={[record.id]} url="/mall_center/put_on_off/batch_on_off" type="off" cb={resetForm} />}
                            {record.status === 2 && <PutOnOffsButton ids={[record.id]} url="/mall_center/put_on_off/batch_on_off" type="on" cb={resetForm} />}
                        </Space>
                    )}
                />
            </Table>
        </div>
    </div>)
}